import { jsx as _jsx } from "react/jsx-runtime";
import "reflect-metadata";
import { XUIProvider } from "@bluelibs/x-ui";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { kernel } from "./kernel";
import "./styles.scss";
ReactDOM.render(_jsx(XUIProvider, { kernel: kernel }, void 0), document.getElementById("root"));
